( function () {
    'use strict';
    e.ecom.productdetails = {};
    e.ecom.productdetails.init = function () {
        if ( jQuery( '.e-productdetails' ).length === 1 ) {
            e.ecom.productdetails.validation();
            e.ecom.variants.init();
            e.ecom.configurator.init();
            e.util.appendPageToBreadcrumb();
            e.ecom.productdetails.loadImageGallery();
        }
    };
    e.ecom.productdetails.validation = function () {
        jQuery( '.js-e-add-to-cart-form' ).validate( {
            errorClass: 'text-error',
            errorElement: 'p',
            errorPlacement: function ( error, element ) {
                error.appendTo( element.closest( 'form' ) );
            },
            highlight: function ( element, errorClass ) {
                jQuery( element ).addClass( errorClass );
            },
            unhighlight: function ( element, errorClass ) {
                jQuery( element ).removeClass( errorClass );
            },
            submitHandler: function ( form ) {
                form.submit();
            }
        } );
    };
    e.ecom.productdetails.loadImageGallery = function () {
        if ( typeof blueimp === 'object' ) {
            jQuery( '.e-productdetails-images' ).on( 'click', '.thumbnail', function ( event ) {
                event.preventDefault();
                var jImageLinks = jQuery( '.e-productdetails-images .thumbnail');
                blueimp.Gallery( jImageLinks.get(), {
                    index: jImageLinks.index( this )
                } );
            } );
        }
    };
}() );
